// Carousel responsiveness
function updateCarouselsForMobile() {

    // On smaller / mobile screens remove carousel functionality
    if (window.innerWidth <= 900) {

        // Get all carousels
        const carousels = document.querySelectorAll('.carousel:not(.carousel-mobile-keep)');

        carousels.forEach(carousel => {

            // 1. Remove the .carousel-item class from all of its children and add .carousel-item-mobile class
            const carouselItems = carousel.querySelectorAll('.carousel-item');
            carouselItems.forEach(item => {
                item.classList.remove('carousel-item');
                item.classList.add('carousel-item-mobile');
            });

            // 2. Remove the .d-flex class from the .carousel-inner children
            const carouselInnerItems = carousel.querySelectorAll('.carousel-inner');
            carouselInnerItems.forEach(item => {
                item.classList.remove('d-flex');
            });

            // 3. Remove the .carousel class from the main element and add .carousel-mobile class
            carousel.classList.remove('carousel');
            carousel.classList.add('carousel-mobile');

            // 4. Hide carousel controls
            const prevControl = carousel.querySelector('.carousel-control-prev');
            prevControl.classList.add('d-none');
            const nextControl = carousel.querySelector('.carousel-control-prev');
            nextControl.classList.add('d-none');
        });
    }
    // On bigger screens set carousel functionality again
    else {

        // Get all carousels
        const carousels = document.querySelectorAll('.carousel-mobile');

        carousels.forEach(carousel => {

            // 1. Add the .carousel-item class to all of its children and remove .carousel-item-mobile class
            const carouselItems = carousel.querySelectorAll('.carousel-item-mobile');
            carouselItems.forEach(item => {
                item.classList.remove('carousel-item-mobile');
                item.classList.add('carousel-item');
            });

            // 2. Add the .d-flex class from the .carousel-inner children
            const carouselInnerItems = carousel.querySelectorAll('.carousel-inner');
            carouselInnerItems.forEach(item => {
                item.classList.add('d-flex');
            });

            // 3. Add the .carousel class to the main element and remove .carousel-mobile class
            carousel.classList.remove('carousel-mobile');
            carousel.classList.add('carousel');

            // 4. Show carousel controls
            const prevControl = carousel.querySelector('.carousel-control-prev');
            prevControl.classList.remove('d-none');
            const nextControl = carousel.querySelector('.carousel-control-prev');
            nextControl.classList.remove('d-none');
        });
    }
}
// Call on load and on every resize
updateCarouselsForMobile();
window.addEventListener('resize', updateCarouselsForMobile);

// Header background: when scrolled to top it is transparent, but when scrolled down it transforms to white
document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('body.home .elementor-243 .elementor-element.elementor-element-74d68656');
    if (!header) return;

    const toggleHeaderBg = () => {
        if (window.scrollY > 200) {
            header.classList.add('bg-white');
        } else {
            header.classList.remove('bg-white');
        }
    };

    // Run once on load in case the page is opened scrolled
    toggleHeaderBg();

    // Update on scroll
    window.addEventListener('scroll', toggleHeaderBg, { passive: true });
});